<div>
  <div>
    <p mat-dialog-title>{{ title }}</p>
  </div>
  <div>
    <p mat-dialog-content>{{ message }}</p>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button mat-flat-button type="button" class="nrg-error-raised-button" (click)="onCancel()">
      <mat-icon>{{ cancelIcon }}</mat-icon>
      {{ cancelText }}
    </button>
    <button mat-raised-button color="primary" (click)="onConfirm()">
      <mat-icon>{{ confirmIcon }}</mat-icon>
      {{ confirmText }}
    </button>
  </div>
</div>
